// A synthetic "not found" error for route-level not-found pages (router catch-alls),
// so they can use the error-driven ErrorDetails component: getErrorCategory reads the
// status and classifies it as 'notFound'.
export const notFoundError = (): Error & { status: number } => Object.assign(new Error('Not found'), { status: 404 });
